import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NoteModal } from 'src/components/ui/GlobalComponents/NoteModal/NoteModal';
import { useCustomList } from 'src/hook/data/useCustomList';
import { useLearning } from 'src/hook/data/useLearning';
import { useShare } from '../../../../hook/global/useShare';
import { useToast } from '../../../../hook/global/useToasts';
import { ContentType, MenuPosition } from '../../../../model/enum/enums';
import { Word } from '../../../../model/Word';
import { insertIntoQueue } from '../../../../utils/QueueUtils';
import { GetQueueUrl, GetWebSiteDictionaryUrl, IconLocation } from '../../../../utils/URLUtils';
import DropdownMenu from '../../../ui/Features/DropDownMenu/DropdownMenu';
import { AddToListModal } from './AddToListModal/AddToListModal';
import { CreateNewListModal } from './CreateNewListModal/CreateNewListModal';
import styles from './MoreOptionsMenu.module.scss';

interface MoreOptionsMenuProps {
    isOpen: boolean;
    onClose: () => void;
    trigger: HTMLSpanElement | null;
    word: Word;
    senseId: string;
}

const MoreOptionsMenu: FC<MoreOptionsMenuProps> = ({ isOpen, onClose, trigger, word, senseId }) => {
    const toast = useToast();
    const { share } = useShare();
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
    const [isAddToListModalOpen, setIsAddToListModalOpen] = useState(false);
    const [isCreateNewListModalOpen, setIsCreateNewListModalOpen] = useState(false);
    const { learningInfo } = useLearning();
    const { addWordToCustomList } = useCustomList();
    const { t } = useTranslation();

    const handleShare = async () => {
        share(`Learn ${word.Text} \n ${GetWebSiteDictionaryUrl(word.Text)}`);
        onClose();
    };

    const handleReport = async () => {
        let jsonData = JSON.stringify({
            WordId: word.ID,
            Word: word.Text,
            Type: ContentType.Image,
            ContentId: word.PrimarySenseId,
            Reason: ""
        });

        insertIntoQueue(GetQueueUrl('bad-video'), jsonData);
        toast.showSuccess('Thank you for caring.');
        onClose();
    };

    const handleNoteModal = () => {
        setIsNoteModalOpen(true);
        onClose();
    };

    const handleFavorite = () => {
        const list = learningInfo?.WordLists
            .find(list => list.ID === "0");
        onClose();
        if (list) {
            addWordToCustomList(list, word, senseId);
            toast.showSuccess('Added to favorite.');
        }

    }

    const handleAddToList = () => {
        setIsAddToListModalOpen(true);
        onClose();
    }


    return (
        <>
            {isOpen &&


                <DropdownMenu
                    isOpen={isOpen}
                    onClose={onClose}
                    trigger={trigger}
                    position={MenuPosition.BottomLeft}
                >
                    <div className={styles.menuItems}>
                        <div className={styles.menuItem} onClick={handleShare}>
                            <img src={IconLocation('share2')} alt="Share" />
                            <span>{t('Share')}</span>
                        </div>
                        <div className={styles.menuItem} onClick={handleNoteModal}>
                            <img src={IconLocation('clipboard')} alt="Note" />
                            <span>{t('Add Note')}</span>
                        </div>
                        <div className={styles.menuItem} onClick={handleFavorite}>
                            <img src={IconLocation('star')} alt="Favorite" />
                            <span>{t('Favorite')}</span>
                        </div>
                        <div className={styles.menuItem} onClick={handleAddToList}>
                            <img src={IconLocation('bookmark')} alt="Share" />
                            <span>{t('Add to list')}</span>

                        </div>
                        <div className={styles.menuItem} onClick={handleReport}>
                            <img src={IconLocation('flag_contextmenu')} alt="Report" />
                            <span>{t('Report Image')}</span>
                        </div>
                    </div>
                </DropdownMenu>
            }

            {isNoteModalOpen &&
                <NoteModal
                    isOpen={isNoteModalOpen}
                    onClose={() => setIsNoteModalOpen(false)}
                    word={word}
                    senseId={senseId}
                />
            }
            {isAddToListModalOpen &&
                <AddToListModal
                    isOpen={isAddToListModalOpen}
                    onClose={() => setIsAddToListModalOpen(false)}
                    word={word}
                    senseId={senseId}
                    setIsCreateNewListModalOpen={setIsCreateNewListModalOpen}
                />
            }
            {isCreateNewListModalOpen &&
                <CreateNewListModal
                    isOpen={isCreateNewListModalOpen}
                    onClose={() => setIsCreateNewListModalOpen(false)}
                    word={word}
                    senseId={senseId}
                />
            }

        </>
    );
};


export default MoreOptionsMenu;